import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { AsyncPaginate } from "react-select-async-paginate";
import { components } from "react-select";
import { ForeignData_API } from "../../APIs/ForeignData.api";
import label from "../../cpn/inputs/label";
import { useFetcher } from "react-router-dom";

export default function Acount(props) {
  const {
    lang,
    proxy,
    foreignField,
    setUser,
    user,
    currentForeign,
    editUser,
    setEditUser,
  } = props;
  const { functions } = useSelector((state) => state);
  const { normalizeStringAccent } = functions;
  const [isWarehouse, setWarehouse] = useState();
  const { foreign_keys } = foreignField;
  const _token = localStorage.getItem("_token");
  const [selectedValue, setSelectedValue] = useState();
  const [data, setData] = useState({
    options: [],
    hasMore: false,
    additional: {
      page: 0,
    },
  });
  const customStyles = {
    control: (styles, { isSelected }) => ({
      ...styles,
      minHeight: 0,
      height: "34px",
      color: isSelected ? "#888787" : "#888787",
      border: "1px solid #ced4da",
    }),
    container: (base) => ({
      ...base,
      padding: "2px 0px",
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
      marginTop: 11,
      boxShadow: ".25rem",
      borderRadius: "0px",
      width: "100%",
      borderRadius: 0,
      border: "1px solid #ced4da",
    }),
    option: (styles, { isSelected, isFocused }) => {
      return {
        ...styles,
        color: "#888787",
        fontWeight: "300",
        cursor: "pointer",
        backgroundColor: isSelected
          ? "#e6e6e6"
          : isFocused
          ? "#e6e6e6"
          : undefined,
        display: "flex",
        alignItems: "center",
      };
    },
    singleValue: (styles) => ({
      ...styles,
      color: "#888787",
    }),
    menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
    valueContainer: (provided) => ({
      ...provided,
      whiteSpace: "nowrap",
      overflow: "hidden",
      flexWrap: "nowrap",
    }),
    multiValueLabel: (base) => ({
      ...base,
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      overflow: "hidden",
    }),
    placeholder: (base) => ({
      ...base,
      maxWidth: "100%",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      overflow: "hidden",
    }),
  };

  useEffect(() => {
    const fetchData = async () => {
      if (foreign_keys && foreign_keys.length > 0) {
        try {
          const res = await ForeignData_API.get(proxy(), _token, {
            table_id: foreign_keys.map((item) => item.table_id),
          });
          const { success, data } = res;
          if (data) {
            const find = data.find(
              (item) => item["11MK"] === editUser?.warhouse
            );

            if (find) {
              setWarehouse(find?.["4TK"]);
            }
          }
        } catch (error) {}
      }
    };
    fetchData();
  }, [foreign_keys, editUser]);

  const filterData = (data, search) => {
    search = normalizeStringAccent(String(search));

    const filteredOptions = data.options.filter((item) => {
      item.label = normalizeStringAccent(String(item?.label));
      return item.label.toLowerCase().includes(search.toLowerCase());
    });

    return {
      ...data,
      options: filteredOptions,
    };
  };
  const handleGetData = async (page = 0, search = "") => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await ForeignData_API.get(proxy(), _token, {
          table_id: foreign_keys.map((item) => item.table_id),
          start_index: page,
          search,
        });
        const { success, data } = res;
        let newData = {
          options: [],
          hasMore: false,
          additional: {
            page: 0,
          },
        };
        if (data && data.length) {
          const primary_key = foreign_keys.map((item) => item.ref_field_id);
          const alias = res.fields.find(
            (field) => field.id === primary_key[0]
          )?.fomular_alias;

          const uniqueValues = new Set();
          const options = [];
          let maxLength = 0;
          setData((prev) => {
            data.map((item) => {
              const name = item[res?.fields[1]?.fomular_alias];
              const value = item[alias];
              if (!uniqueValues.has(value)) {
                uniqueValues.add(value);
                if (value) {
                  options.push({
                    label: name,
                    value: value,
                    alias: name,
                  });
                  maxLength = Math.max(maxLength, value.length);
                }
              }
            });
            // setWidth(7 * maxLength + 100);
            newData = {
              additional: { page: page + 15 },
              hasMore: res.data.length ? true : false,
              options: options,
            };
            return {
              additional: { page: page + 15 },
              hasMore: res.data.length ? true : false,
              options: [
                ...prev.options,
                ...res.data.map((item) => ({
                  label: item[res?.fields[1]?.fomular_alias],
                  value: item[alias],
                  alias: alias,
                })),
              ],
            };
          });
        }
        setTimeout(() => {
          resolve(filterData(newData, search));
        }, 100);
      } catch (err) {
        console.log("OPTION ERROR:", err);
        reject(err);
      }
    });
  };
  const CustomOption = ({ children, ...props }) => {
    return (
      <>
        <components.Option {...props}>
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
            style={{ marginRight: 10 }}
          />
          {children}
        </components.Option>
      </>
    );
  };
  return (
    <>
      <AsyncPaginate
        components={{
          Option: CustomOption,
          // DropdownIndicator: () => null,
          // IndicatorSeparator: () => null,
        }}
        // closeMenuOnSelect={false}
        // hideSelectedOptions={false}
        // menuPosition={"fixed"}
        placeholder={lang["select value"]}
        loadOptions={async (search, loadedOptions, { page }) => {
          return await handleGetData(page, search);
        }}
        value={
          editUser?.warhouse
            ? {
                label: isWarehouse,
                value: editUser,
              }
            : selectedValue
            ? selectedValue
            : null
        }
        onChange={(props) => {
          props.map((item) => {
            setSelectedValue({
              label: item.label,
              value: item.value,
            });
            setUser({
              ...user,
              warhouse: item.value,
            });
            if (editUser) {
              setEditUser({
                ...editUser,
                warhouse: item.value,
              });
            }
          });
        }}
        styles={customStyles}
        // value={editUser?.warhouse}
        additional={{
          page: 0,
        }}
        isMulti
        // defaultMenuIsOpen
        // menuIsOpen={menuIsOpen}
        noOptionsMessage={() => (
          <div style={{ fontWeight: "300" }}>{lang["not found data"]}</div>
        )}
        // allowCreateWhileLoading={false}
      />
    </>
  );
}
